import React from 'react';

const GallerySection = () => {
  const galleryImages = [
    { thumb: '/images/gallery/1.jpg', full: '/images/gallery/1.jpg' },
  { thumb: '/images/gallery/2.jpg', full: '/images/gallery/2.jpg' },
  { thumb: '/images/gallery/3.jpg', full: '/images/gallery/3.jpg' },
  { thumb: '/images/gallery/4.jpg', full: '/images/gallery/4.jpg' },
  { thumb: '/images/gallery/5.jpg', full: '/images/gallery/5.jpg' },
  { thumb: '/images/gallery/6.jpg', full: '/images/gallery/6.jpg' },
  { thumb: '/images/gallery/7.jpg', full: '/images/gallery/7.jpg' },
  { thumb: '/images/gallery/8.jpg', full: '/images/gallery/8.jpg' },
  { thumb: '/images/gallery/9.jpg', full: '/images/gallery/9.jpg' },
  { thumb: '/images/gallery/10.jpg', full: '/images/gallery/10.jpg' },
  { thumb: '/images/gallery/11.jpg', full: '/images/gallery/11.jpg' },
  { thumb: '/images/gallery/12.jpg', full: '/images/gallery/12.jpg' },
  { thumb: '/images/gallery/13.jpg', full: '/images/gallery/13.jpg' },
  { thumb: '/images/gallery/14.jpg', full: '/images/gallery/14.jpg' },
  { thumb: '/images/gallery/15.jpg', full: '/images/gallery/15.jpg' },
  { thumb: '/images/gallery/16.jpg', full: '/images/gallery/16.jpg' },
  { thumb: '/images/gallery/17.jpg', full: '/images/gallery/17.jpg' },
  { thumb: '/images/gallery/18.jpg', full: '/images/gallery/18.jpg' },
  { thumb: '/images/gallery/19.jpg', full: '/images/gallery/19.jpg' },
  { thumb: '/images/gallery/20.jpg', full: '/images/gallery/20.jpg' },
  { thumb: '/images/gallery/21.jpg', full: '/images/gallery/21.jpg' },
  { thumb: '/images/gallery/22.jpg', full: '/images/gallery/22.jpg' },
   { thumb: '/images/fleet/Scorpio.jpg', full: '/images/fleet/Scorpio.jpg' },
  { thumb: '/images/fleet/Tavera.jpg', full: '/images/fleet/Tavera.jpg' },
  { thumb: '/images/fleet/Toyota-corolla-Altis.jpg', full: '/images/fleet/Toyota-corolla-Altis.jpg' },
  { thumb: '/images/fleet/Toyota-Innova.jpg', full: '/images/fleet/Toyota-Innova.jpg' },
  { thumb: '/images/fleet/Honda-Amaze.jpg', full: '/images/fleet/Honda-Amaze.jpg' },
  { thumb: '/images/fleet/Innova-Crysta.jpg', full: '/images/fleet/Innova-Crysta.jpg' },
  { thumb: '/images/fleet/Maruti-Ertiga.jpg', full: '/images/fleet/Maruti-Ertiga.jpg' },
  { thumb: '/images/fleet/Maruti-swift-Dzire.jpg', full: '/images/fleet/Maruti-swift-Dzire.jpg' },
  { thumb: '/images/fleet/mini-bus.jpg', full: '/images/fleet/mini-bus.jpg' }

  ];

  return (


<>
 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title">Gallery</h2>
           
          </div>
        </div>
      </div>
    </div>




    <section className="section gallery-section ">
      <div className="container">
        <div className="row">
          {galleryImages.map((img, index) => (
            <div
              key={index}
              className="col-lg-4 col-md-6 col-sm-6 col-12 "
              data-aos="fade-down"
            >
              <div className="gallery-widget borderr">
                <a data-fancybox="gallery2">
                  <img className="img-fluid" src={img.thumb} alt={`Gallery ${index + 1}`} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

</>
  );
};

export default GallerySection;